import React from 'react';

import Support from './custom/Support';
import './Footer.scss';

const Footer = () => {
  return (
    <footer className="app-footer">
      <Support />
    </footer>
  );
};

export default Footer;
